var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadMobileAppStyling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 935,
    height: 627,
    viewBox: "0 0 935 627",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M880.783 194.644C1019.85 152.139 1267.49 -20.2484 1462.82 2.29947C1658.15 24.8473 1859.52 255.329 2053.29 295.708C2247.06 336.087 2512.49 304.687 2585.94 405.301C2560.88 484.153 1933.99 642.381 1730.36 698.659C1535.22 752.593 1294.08 749.869 1067.7 764.723C863.569 778.117 655.392 799.227 478.049 780.831C291.388 761.468 139.013 720.113 63.8479 660.589C-11.8968 600.606 -20.4852 486.584 40.8149 413.6C101.986 340.77 277.478 222.277 505.012 231.404C732.546 240.531 741.718 237.149 880.783 194.644Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 1039.59,
    y1: 242.361,
    x2: 1041.92,
    y2: 413.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4B1C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C81C0",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadMobileAppStyling);
export default __webpack_public_path__ + "static/media/download_mobile_app_styling.703d3d148bf24686b500e19643e4c62d.svg";
export { ForwardRef as ReactComponent };